export enum UserTypes {
  TYPE_SUPER_ADMIN = 1000,
  TYPE_RAKAZ_MAAGAL = 900,
  TYPE_RAKAZ_MAHOZ = 800,
  TYPE_RAKAZ_KEN = 700,
  TYPE_GARIN_INSTRUCTOR = 25,
  TYPE_MESHUTAF = 20,
  TYPE_VIEWER = 30,
  TYPE_TALPAN = 40,
  TYPE_TALPAN_WITH_MOBILE = 45,
  TYPE_MOBILE_ONLY = 50,
}

export enum PaymentTypes {
  PAYMENT_TYPE_CREDIT = 1,
  PAYMENT_TYPE_CREDIT_PARTLY_REFUNDED = 2,
  PAYMENT_TYPE_CREDIT_TOTALLY_REFUNDED = 3,
  PAYMENT_TYPE_CASH = 4,
  PAYMENT_TYPE_CHEQUE = 5,
  PAYMENT_TYPE_CASH_AND_CHEQUE = 6,
  PAYMENT_TYPE_CASH_WITH_CHEQUE = 7,
  PAYMENT_TYPE_CASH_PARTLY_REFUNDED = 8,
  PAYMENT_TYPE_CASH_TOTALLY_REFUNDED = 9,
  PAYMENT_TYPE_MESHUTAF = 10,
  PAYMENT_TYPE_MESHUTAF_PARTLY_REFUNDED = 11,
  PAYMENT_TYPE_MESHUTAF_TOTALLY_REFUNDED = 12,
}

export enum CheckoutTypeEnum {
  PARENT,
  TALPAN,
  CASH_ONLY,
  RAKAZ_OR_TALPAN_WITH_CASH,
  MESHUTAF,
}

export enum ForgetPasswordEnum {
  EMAIL = "EMAIL",
  SMS = "SMS",
  COPY = "COPY",
}

export enum RefundActionTypeEnum {
  APPROVE = "APPROVE",
  DENY = "DENY",
  COMMENT = "COMMENT",
  RENEW = "RENEW",
}



// WEBPACK FOOTER //
// ./src/app/_models/types.ts